import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page } from '../components/ui/Page';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Kicker } from '../components/ui/Kicker';
import { Icon } from '../components/ui/Icon';

const STATS = [
  { v: '2.4M+', l: 'Shipments' },
  { v: '24', l: 'Carriers' },
  { v: '40+', l: 'Countries' },
  { v: '98.6%', l: 'On-time' },
];

const PRINCIPLES = [
  { t: 'Transparent pricing', d: 'No hidden fuel surcharges, no mystery markups. You see what we see.' },
  { t: 'One platform, every carrier', d: 'Never log into another carrier dashboard. Ever.' },
  { t: 'Built for developers', d: 'Great UI for humans. Great API for machines. Both first-class.' },
  { t: 'Local expertise, global reach', d: 'Teams in Ramallah and Sheridan, Wyoming — because shipping is local.' },
];

const AboutPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Page width="narrow">
      <div style={{ paddingTop: 24 }}>
        <Kicker>About</Kicker>
        <h1 style={{
          fontSize: 'clamp(36px, 5vw, 52px)',
          fontWeight: 600,
          letterSpacing: '-0.03em',
          marginTop: 16,
          lineHeight: 1.05,
        }}>
          We're building the{' '}
          <span style={{ fontFamily: 'var(--font-disp)', fontStyle: 'italic', fontWeight: 400 }}>
            shipping layer
          </span>{' '}
          of modern commerce.
        </h1>
        <p style={{ fontSize: 18, color: 'var(--ink-2)', marginTop: 20, maxWidth: 640, lineHeight: 1.55 }}>
          Almaship started in 2023 with one mission: make cross-border shipping from Palestine to the USA
          feel like Stripe, not like a fax machine. Today we serve 8,400+ merchants across 40+ countries
          with negotiated rates on 24 carriers.
        </p>
      </div>

      {/* Stats grid */}
      <div className="about-stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24, marginTop: 40 }}>
        {STATS.map(({ v, l }) => (
          <div key={l}>
            <div style={{ fontSize: 40, fontWeight: 600, letterSpacing: '-0.02em' }}>{v}</div>
            <div className="muted">{l}</div>
          </div>
        ))}
      </div>

      {/* Team placeholder */}
      <div className="ph" style={{ height: 280, marginTop: 40 }}>
        TEAM · warehouse or office
      </div>

      {/* Principles */}
      <h2 style={{ fontSize: 32, marginTop: 56, letterSpacing: '-0.02em' }}>Our principles</h2>
      <div className="about-principles" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, marginTop: 20 }}>
        {PRINCIPLES.map(({ t, d }) => (
          <Card key={t} style={{ padding: 24 }}>
            <h3 style={{ fontSize: 17 }}>{t}</h3>
            <p className="muted" style={{ marginTop: 6, fontSize: 14 }}>{d}</p>
          </Card>
        ))}
      </div>

      {/* CTA */}
      <div
        className="card"
        style={{
          padding: 36,
          marginTop: 40,
          background: 'linear-gradient(135deg, var(--brand-navy), var(--brand-ink))',
          color: '#fff',
          border: 'none',
          textAlign: 'center',
        }}
      >
        <h3 style={{ fontSize: 24, color: '#fff' }}>Ready to ship with us?</h3>
        <p style={{ marginTop: 8, color: '#cfd1e4' }}>
          Join 8,400+ merchants who trust Almaship for their logistics.
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 20 }}>
          <Button
            variant="primary"
            onClick={() => navigate('/shipping')}
            style={{ background: 'var(--brand-cyan)', color: 'var(--brand-navy)' }}
          >
            <Icon name="package" size={15} /> Start shipping
          </Button>
          <Button variant="ghost" onClick={() => navigate('/contact')} style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}>
            Contact us
          </Button>
        </div>
      </div>
    </Page>
  );
};

export default AboutPage;
